$(document).ready(function () {
    'use strict';

    let body = $('body');

    // ************* YOUTUBE VIDEOS **************//
    body.on('click', '.youtube-video-anchor', function(e) {
        e.preventDefault();
        let videoId = $(this).data('id');
        let modalForm = $('#modal-video');

        $('#overlay').fadeIn(400,
            function() {
                modalForm.css('display', 'flex').animate({opacity: 1, top: '50%'}, 200);
                modalForm.find('#modal-content').html('<iframe class="youtube-video" width="1000" height="600" src="https://www.youtube.com/embed/' + videoId + '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
            });
        e.stopPropagation();
    });

    $('#modal-close, #overlay').click( function() {
        $('#modal-alert, #modal-video')
            .animate({opacity: 0, top: '100px'}, 200,
                function() {
                    $(this).css('display', 'none');
                    $('#overlay').fadeOut(400);
                }
            );
        let vid = body.find('.youtube-video'),
            src = vid.prop('src');
        vid.prop('src', '').prop('src', src.replace('?autoplay=1', ''));

    });

    body.on('click', '.mobile-menu-button', function (e) {
        e.preventDefault();

        let modal = body.find('.mobile-menu-modal');

        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            $(this).addClass('active');
        }

        if (modal.hasClass('active')) {
            modal.removeClass('active');
            $('#overlay-white').fadeOut(400);
        } else {
            modal.addClass('active');
            $('#overlay-white').fadeIn(400);
        }
    });


});
